// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2ESw_","footer":"ModalError_footer__1wFjo"};